'use client';

import { useQuery } from '@tanstack/react-query';
import { characterKeys } from '../queryKeys';
import { getCharacter } from '../actions/getCharacter';
import type { Character } from '../types';

export function useCharacter(characterId: string | null | undefined) {
  const query = useQuery<Character | null>({
    queryKey: characterKeys.detail(characterId ?? ''),
    queryFn: () => getCharacter(characterId!),
    enabled: !!characterId,
  });
  return query;
}
